var ArticleSubtitle = function ArticleSubtitle(_ref) {
  var type = _ref.type,
    subtitle = _ref.subtitle,
    showProductBuyLink = _ref.showProductBuyLink;
  if (type !== 'product' || !showProductBuyLink) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "a__buy-product"
  }, /*#__PURE__*/React.createElement("a", {
    href: "mailto:materials@posillicoinc.com?subject=Products Inquiry&body=I am interested in purchasing ".concat(subtitle)
  }, "Buy ", subtitle));
};
export default ArticleSubtitle;